var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0.5,
    fill: "currentColor",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.195,
    d: "M16.303 11.285a2.15 2.15 0 0 0 .639-1.543c0-.587-.227-1.136-.638-1.548a2.19 2.19 0 0 0-3.09 0l-1.116 1.122-.069-.069.07.069a.665.665 0 1 1-.943-.938l1.117-1.122a3.52 3.52 0 0 1 4.971-.002 3.5 3.5 0 0 1 1.028 2.488c0 .944-.365 1.827-1.03 2.485l-1.113 1.12a.665.665 0 0 1-.943-.94m1.117-1.122-1.048 1.191-.069-.069m1.117-1.122-1.117 1.122m1.117-1.122-1.117 1.122m-4.945 5.364c.899 0 1.798-.342 2.482-1.027l1.123-1.117a.664.664 0 1 0-.937-.942l.068.069-.068-.07-1.124 1.119a2.19 2.19 0 0 1-3.09 0 2.19 2.19 0 0 1-.002-3.088l1.123-1.117a.664.664 0 1 0-.937-.943l.068.069-.068-.069-1.124 1.118a3.517 3.517 0 0 0 0 4.97 3.5 3.5 0 0 0 2.486 1.028Zm0 0v-.098.098Zm4.445-7.02a.664.664 0 1 0-.94-.94l-3.42 3.42a.664.664 0 1 0 .94.94z"
  })));
};
export default SvgIconShare;